import { Injectable, signal } from '@angular/core';
import { STORAGE_KEYS } from '../constants/storage-keys';

export type ThemeName = 'clean' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly theme = signal<ThemeName>(this.readInitialTheme());

  constructor() {
    this.applyTheme(this.theme());
  }

  toggleTheme(): void {
    this.setTheme(this.theme() === 'clean' ? 'dark' : 'clean');
  }

  setTheme(theme: ThemeName): void {
    this.theme.set(theme);
    this.applyTheme(theme);
    localStorage.setItem(STORAGE_KEYS.theme, theme);
  }

  private applyTheme(theme: ThemeName): void {
    document.body.setAttribute('data-theme', theme);
  }

  private readInitialTheme(): ThemeName {
    const stored = localStorage.getItem(STORAGE_KEYS.theme) as ThemeName | null;
    return stored ?? 'clean';
  }
}
